import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './Pages/Home';
import Pricing from './Pages/Pricing/index';
import PricingTwo from './Pages/PricingTwo';
import Templete from './Pages/Templete';

const Router = () => {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/home" exact component={Home} />
          <Route path="/templates" exact component={Templete} />
          <Route path="/pricing" exact component={Pricing} />
          <Route path="/pricingtwo" exact component={PricingTwo} />
        </Switch>
      </BrowserRouter>
    );
}

export default Router
